import React from 'react';
import clsx from 'clsx';
import { Loader } from 'semantic-ui-react';
import BasicAuthErrorsWrapper from '@/components/errors/BasicAuthErrorsWrapper';
import BasicErrorsWrapper from '@/components/errors/BasicErrorsWrapper';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import HoverActionHeader from '@/components/HoverActionHeader';

const DatasetWizardContentContainer = ({
  category,
  children,
  className,
  code,
  loading,
  readErrors,
  saveErrors = [],
  title,
  updateProperties,
}) => (
  <div className={clsx('aridhia-wizard-content', className)}>
    <HoverActionHeader value={title} icon="table" className="aridhia-catalogue-list-header" />
    {loading && (<Loader active inline="centered" />)}
    {!loading && (
    <BasicAuthErrorsWrapper errors={readErrors}>
      <BasicErrorsWrapper canAccess errors={readErrors} exists entity="dataset">
        <EntitiesErrorMessages
          category={category}
          code={code}
          contexts={['dictionaryUUID', 'fieldUUID']}
          entities={['dataset', 'server']}
          entity="dataset"
          errors={saveErrors}
          onDismiss={(errors) => updateProperties(category, code, { saveErrors: errors })}
        />
        {children}
      </BasicErrorsWrapper>
    </BasicAuthErrorsWrapper>
    )}
  </div>
);

export default DatasetWizardContentContainer;
